import { Pipe, PipeTransform } from '@angular/core';

import { VariableSummary } from '@mtna/pojo-consumer-ui';

import { BaseFilter } from '../core/models/filter/index';

@Pipe({
  name: 'rdsGetFilterValue',
})
export class RdsGetFilterValuePipe implements PipeTransform {
  transform(
    count: number,
    filters: Array<BaseFilter<VariableSummary>>,
    multiVariableSelect: boolean
  ): VariableSummary | Array<VariableSummary> {
    if (count === 0) {
      return multiVariableSelect ? [] : null;
    }

    return multiVariableSelect ? filters.filter((f) => !!f.variable).map((f) => f.variable) : filters[0].variable;
  }
}
